import { Group } from '@mantine/core';
import type { ProjectsResponse } from '../../../../api/projects-client/projects-client.type';
import { toggleCapacityTeamSelection } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { baseBlack } from '../../../../styles/design-tokens';
import { Checkbox } from '../../../../ui-library/checkbox/checkbox';
import { Text } from '../../../../ui-library/typography/typography';

type Props = {
  team: ProjectsResponse;
  isSelected: boolean;
};

export const CapacityItem = ({ team, isSelected }: Props) => {
  const handleTeamToggle = () => {
    toggleCapacityTeamSelection(team.id);
  };

  return (
    <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
      <Checkbox checked={isSelected} onChange={handleTeamToggle} size="sm" />
      <Text
        size="small"
        color={baseBlack}
        style={{
          cursor: 'pointer',
          flex: 1,
        }}
        onClick={handleTeamToggle}
      >
        {team.name}
      </Text>
    </Group>
  );
};
